export default "__VITE_ASSET__274d93d6__"